"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = void 0;

var _core = require("@clayui/core");

var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));

var _form = require("@clayui/form");

var _loadingIndicator = _interopRequireDefault(require("@clayui/loading-indicator"));

var _shared = require("@clayui/shared");

var _react = _interopRequireWildcard(require("react"));

var _Context = require("./Context");

var _excluded = ["children"],
    _excluded2 = ["UNSAFE_loadingShrink", "active", "alignmentByViewport", "allowsCustomValue", "as", "children", "containerElementRef", "defaultActive", "defaultItems", "defaultValue", "direction", "filterKey", "items", "loadingState", "menuTrigger", "messages", "onActiveChange", "onChange", "onItemsChange", "onLoadMore", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Collection = _core.__NOT_PUBLIC_COLLECTION.Collection,
    useCollection = _core.__NOT_PUBLIC_COLLECTION.useCollection,
    useVirtual = _core.__NOT_PUBLIC_COLLECTION.useVirtual;
var LiveAnnouncer = _core.__NOT_PUBLIC_LIVE_ANNOUNCER.LiveAnnouncer;

var List = /*#__PURE__*/_react.default.forwardRef(function List(_ref, ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("ul", _extends({}, otherProps, {
    className: "list-unstyled",
    ref: ref
  }), children);
});

function hasItem(items, value, filterKey) {
  return items.find(function (item) {
    if (typeof item === 'string') {
      return item === value;
    } else if (_typeof(item) === 'object') {
      // filter key is not defined and we cannot infer the data type.
      if (!filterKey) {
        return false;
      }

      return item[filterKey] === value;
    }
  });
}

var ESCAPE_REGEXP = /[.*+?^${}()|[\]\\]/g;
var defaultMessages = {
  listCount: '{0} option available.',
  listCountPlural: '{0} options available.',
  loading: 'Loading...',
  notFound: 'No results found'
};

function AutocompleteInner(_ref2, ref) {
  var _messages, _containerElementRef$;

  var UNSAFE_loadingShrink = _ref2.UNSAFE_loadingShrink,
      externalActive = _ref2.active,
      _ = _ref2.alignmentByViewport,
      allowsCustomValue = _ref2.allowsCustomValue,
      _ref2$as = _ref2.as,
      As = _ref2$as === void 0 ? _form.ClayInput : _ref2$as,
      children = _ref2.children,
      containerElementRef = _ref2.containerElementRef,
      defaultActive = _ref2.defaultActive,
      defaultItems = _ref2.defaultItems,
      defaultValue = _ref2.defaultValue,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? 'bottom' : _ref2$direction,
      filterKey = _ref2.filterKey,
      externalItems = _ref2.items,
      loadingState = _ref2.loadingState,
      _ref2$menuTrigger = _ref2.menuTrigger,
      menuTrigger = _ref2$menuTrigger === void 0 ? 'input' : _ref2$menuTrigger,
      messages = _ref2.messages,
      onActiveChange = _ref2.onActiveChange,
      onChange = _ref2.onChange,
      onItemsChange = _ref2.onItemsChange,
      onLoadMore = _ref2.onLoadMore,
      externalValue = _ref2.value,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  messages = _objectSpread(_objectSpread({}, defaultMessages), (_messages = messages) !== null && _messages !== void 0 ? _messages : {});

  var _useControlledState = (0, _shared.useControlledState)({
    defaultName: 'defaultItems',
    defaultValue: defaultItems,
    handleName: 'onItemsChange',
    name: 'items',
    onChange: onItemsChange,
    value: externalItems
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 3),
      items = _useControlledState2[0],
      isItemsUncontrolled = _useControlledState2[2];

  var _useControlledState3 = (0, _shared.useControlledState)({
    defaultName: 'defaultValue',
    defaultValue: defaultValue,
    handleName: 'onChange',
    name: 'value',
    onChange: onChange,
    value: externalValue
  }),
      _useControlledState4 = _slicedToArray(_useControlledState3, 3),
      _useControlledState4$ = _useControlledState4[0],
      value = _useControlledState4$ === void 0 ? '' : _useControlledState4$,
      setValue = _useControlledState4[1],
      isUncontrolled = _useControlledState4[2];

  var _useControlledState5 = (0, _shared.useControlledState)({
    defaultName: 'defaultActive',
    defaultValue: defaultActive,
    handleName: 'onActiveChange',
    name: 'active',
    onChange: onActiveChange,
    value: externalActive
  }),
      _useControlledState6 = _slicedToArray(_useControlledState5, 2),
      active = _useControlledState6[0],
      setActive = _useControlledState6[1];

  var inputRef = (0, _react.useRef)(null);
  var menuRef = (0, _react.useRef)(null);
  var shouldIgnoreOpenMenuOnFocus = (0, _react.useRef)(false);
  var inputElementRef = ref || inputRef;
  var isLoading = Boolean(loadingState !== undefined && loadingState === 1);
  var debouncedLoadingChange = (0, _shared.useDebounce)(isLoading, 500);
  var currentItemSelected = (0, _react.useRef)('');
  var ariaControlsId = (0, _shared.useId)();
  var announcerAPI = (0, _react.useRef)(null);
  var isFirst = (0, _shared.useIsFirstRender)();
  var filterFn = (0, _react.useCallback)(function (itemValue) {
    return itemValue.match(new RegExp(value.replace(ESCAPE_REGEXP, '\\$&'), 'i')) !== null;
  }, [value]);
  (0, _react.useEffect)(function () {
    // Validates that the initial value exists in the items.
    if (!allowsCustomValue && !currentItemSelected.current && value && items) {
      if (hasItem(items, value, filterKey)) {
        currentItemSelected.current = value;
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    // Does not update state on first render, if the custom value is allowed
    // or if the value is empty.
    if (isFirst || allowsCustomValue || !value) {
      return;
    }

    if (active === false && currentItemSelected.current !== value) {
      // The state is controlled so we have to revalidate if the typed value
      // exists in the suggestion list.
      if (!isUncontrolled && items && hasItem(items, value, filterKey)) {
        currentItemSelected.current = value;
        return;
      }

      setValue(currentItemSelected.current);
    }
  }, [active]);
  var filteredItems = (0, _react.useMemo)(function () {
    if (debouncedLoadingChange) {
      return [];
    }

    if (!isItemsUncontrolled) {
      return items !== null && items !== void 0 ? items : [];
    }

    if (!items) {
      return [];
    }

    return items === null || items === void 0 ? void 0 : items.filter(function (option) {
      if (!filterKey && _typeof(option) === 'object') {
        console.warn("<Autocomplete />: the component is trying to filter the list but it doesn't know which key to use for comparison, defines the key in 'filterKey' ('<Autocomplete filterKey=\"value\" />'). option=", option);
        return true;
      }

      return filterFn(filterKey && _typeof(option) === 'object' ? option[filterKey] : option);
    });
  }, [debouncedLoadingChange, isItemsUncontrolled, items, filterFn]);
  var virtualizer = useVirtual({
    estimateSize: 37,
    items: filteredItems,
    parentRef: menuRef
  }); // We initialize the collection in the picker and then pass it down so the
  // collection can be cached even before the listbox is not mounted.

  var collection = useCollection({
    children: children,
    filter: isItemsUncontrolled ? filterFn : undefined,
    filterKey: 'value',
    itemContainer: (0, _react.useCallback)(function (_ref3) {
      var _ref4, _children$props$textV;

      var children = _ref3.children,
          keyValue = _ref3.keyValue;
      var itemValue = (_ref4 = (_children$props$textV = children.props.textValue) !== null && _children$props$textV !== void 0 ? _children$props$textV : children.props.value) !== null && _ref4 !== void 0 ? _ref4 : children.props.children;
      return /*#__PURE__*/_react.default.cloneElement(children, {
        keyValue: keyValue,
        match: value,
        onClick: function onClick(event) {
          var _inputElementRef$curr;

          if (children.props.onClick) {
            children.props.onClick(event);
          }

          if (event.defaultPrevented) {
            return;
          }

          setActive(false);
          currentItemSelected.current = itemValue;
          setValue(itemValue);
          shouldIgnoreOpenMenuOnFocus.current = true;
          (_inputElementRef$curr = inputElementRef.current) === null || _inputElementRef$curr === void 0 ? void 0 : _inputElementRef$curr.focus();
        },
        roleItem: 'option'
      });
    }, [value]),
    items: filteredItems,
    notFound: /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, {
      "aria-disabled": "true",
      className: "disabled",
      roleItem: "option"
    }, messages.notFound),
    suppressTextValueWarning: false,
    virtualizer: items ? virtualizer : undefined
  });

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeDescendant = _useState2[0],
      setActiveDescendant = _useState2[1];

  (0, _shared.useOverlayPosition)({
    alignmentByViewport: true,
    alignmentPosition: direction === 'bottom' ? 5 : 7,
    autoBestAlign: true,
    isOpen: active,
    ref: menuRef,
    triggerRef: containerElementRef
  }, [active, children]);

  var _useNavigation = (0, _shared.useNavigation)({
    activation: 'manual',
    active: activeDescendant,
    collection: collection,
    containerRef: menuRef,
    loop: true,
    onNavigate: function onNavigate(item) {
      return setActiveDescendant(item);
    },
    orientation: 'vertical',
    visible: active
  }),
      navigationProps = _useNavigation.navigationProps; // Resets `activeDescendant` when the menu is closed, this avoids a bug when
  // the `active` state is controlled and closes the menu with different
  // statements than what is expected internally.


  (0, _react.useEffect)(function () {
    if (!active && activeDescendant) {
      setActiveDescendant('');
    }
  }, [active]);
  var optionCount = collection.getItems().length;
  var lastSize = (0, _react.useRef)(optionCount);
  (0, _react.useEffect)(function () {
    // Only announces the number of options available when the menu is open
    // if there is no item with focus, with the exception of Voice Over
    // which does not include the message.
    if (announcerAPI.current && active && (!activeDescendant || (0, _shared.isAppleDevice)() || optionCount !== lastSize.current)) {
      var _optionCount = collection.getItems().length;
      announcerAPI.current.announce((0, _shared.sub)(_optionCount === 1 ? messages.listCount : messages.listCountPlural, [_optionCount]));
    }

    lastSize.current = optionCount;
  }, [active, value]);
  var onClose = (0, _react.useCallback)(function () {
    return setActive(false);
  }, []);
  var onPress = (0, _react.useCallback)(function () {
    if (menuRef.current && activeDescendant) {
      var item = document.getElementById(String(activeDescendant));

      if (item) {
        item.click();
      }
    }
  }, [activeDescendant]);
  var LoadingGroupItem = UNSAFE_loadingShrink ? _form.ClayInput.GroupItem : _form.ClayInput.GroupInsetItem;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(LiveAnnouncer, {
    ref: announcerAPI
  }), /*#__PURE__*/_react.default.createElement(As, _extends({}, otherProps, {
    "aria-activedescendant": active ? String(activeDescendant) : undefined,
    "aria-autocomplete": "list",
    "aria-controls": ariaControlsId,
    "aria-expanded": active,
    autoComplete: "off",
    autoCorrect: "off",
    insetAfter: isLoading,
    onChange: function onChange(event) {
      var value = event.target.value;

      if (!value) {
        currentItemSelected.current = value;
      }

      if (items !== null) {
        setActive(true);
      }

      setValue(value);

      if (activeDescendant) {
        setActiveDescendant('');
      }
    },
    onFocus: function onFocus(event) {
      if (otherProps.onFocus) {
        otherProps.onFocus(event);
      }

      if (menuTrigger === 'focus' && items !== null) {
        if (shouldIgnoreOpenMenuOnFocus.current) {
          shouldIgnoreOpenMenuOnFocus.current = false;
          return;
        }

        setActive(true);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (otherProps.onKeyDown) {
        otherProps.onKeyDown(event);
      }

      switch (event.key) {
        case _shared.Keys.Tab:
        case _shared.Keys.Esc:
          {
            setActive(false);
            break;
          }

        case _shared.Keys.Enter:
          {
            setActive(false);

            if (active && activeDescendant) {
              onPress();
            }

            if (!active && event.key === _shared.Keys.Esc) {
              setValue('');
            }

            break;
          }

        case _shared.Keys.Home:
        case _shared.Keys.End:
          {
            setActiveDescendant('');
            break;
          }

        case _shared.Keys.Left:
        case _shared.Keys.Right:
          {
            if (activeDescendant) {
              setActiveDescendant('');
            }

            break;
          }

        case _shared.Keys.Up:
        case _shared.Keys.Down:
          {
            event.preventDefault();

            if (!active && event.altKey && event.key === _shared.Keys.Down && items !== null) {
              event.stopPropagation();
              setActive(true);
              return;
            }

            if (!activeDescendant) {
              var item = event.key === _shared.Keys.Down ? collection.getFirstItem() : collection.getLastItem();
              setActiveDescendant(item.key);
            }

            if (!active && items !== null) {
              return setActive(true);
            }

            navigationProps.onKeyDown(event);
            break;
          }

        default:
          navigationProps.onKeyDown(event);
          break;
      }
    },
    ref: inputElementRef,
    role: "combobox",
    spellCheck: false,
    value: value
  })), active && /*#__PURE__*/_react.default.createElement(_shared.Overlay, {
    isCloseOnInteractOutside: true,
    isKeyboardDismiss: true,
    isOpen: true,
    menuRef: menuRef,
    onClose: onClose,
    portalRef: menuRef,
    suppress: [menuRef, inputElementRef],
    triggerRef: inputElementRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-menu dropdown-menu-select show",
    ref: menuRef,
    role: "presentation",
    style: {
      maxWidth: 'none',
      width: "".concat((_containerElementRef$ = containerElementRef.current) === null || _containerElementRef$ === void 0 ? void 0 : _containerElementRef$.clientWidth, "px")
    }
  }, /*#__PURE__*/_react.default.createElement(_Context.AutocompleteContext.Provider, {
    value: {
      activeDescendant: activeDescendant,
      onActiveDescendant: setActiveDescendant,
      onClick: setValue
    }
  }, /*#__PURE__*/_react.default.createElement(Collection, {
    "aria-label": otherProps['aria-label'],
    "aria-labelledby": otherProps['aria-labelledby'],
    as: List,
    collection: collection,
    id: ariaControlsId,
    isLoading: isLoading,
    onLoadMore: onLoadMore,
    role: "listbox"
  }, debouncedLoadingChange ? /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, {
    "aria-disabled": "true",
    className: "disabled",
    roleItem: "option"
  }, messages.loading) : children)))), isLoading && /*#__PURE__*/_react.default.createElement(LoadingGroupItem, {
    after: !UNSAFE_loadingShrink ? true : undefined,
    "aria-label": messages.loading,
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    role: "progressbar",
    shrink: UNSAFE_loadingShrink
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "inline-item inline-item-middle"
  }, /*#__PURE__*/_react.default.createElement(_loadingIndicator.default, {
    size: "sm"
  }))));
}

var Autocomplete = /*#__PURE__*/_react.default.forwardRef(AutocompleteInner);

exports.Autocomplete = Autocomplete;
Autocomplete.displayName = 'Autocomplete';